<h1 class="dgoods-title">
    {{ title }}
</h1>
